/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */

import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import Vue from 'vue';
import { HttpError, PMSError, ValidationError } from '@/errors';

const endpoint = `${apiEndpoint}/management/messages`;

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  let cmt = false;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      cmt = true;
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  if (cmt) {
    commit('updateError', err);
  } else {
    throw err;
  }
}
const state = {
  messages: null,
  message: null,
  messagePending: false,
  paginatedMessages: null,
  pending: false,
  updatePending: false,
  error: null,
  updateError: null,
};

const getters = {
  loaded: (state) => !state.pending && state.messages != null,
  paginateLoaded: (state) => !state.pending && state.paginatedMessages != null,
  messages: (state, getters) => (getters.loaded ? state.messages : []),
  noMessages: (state, getters) => getters.loaded && !getters.messages.length,
  noPaginatedMessages: (state, getters) => getters.loaded && !getters.paginatedMessages.length,
  message: (state) => state.message,
  messagePending: (state) => state.messagePending,

};

const mutations = {
  clearErrors(state) {
    state.error = null;
    state.updateError = null;
  },
  beforeLoading(state, initial = false) {
    if (initial) {
      state.group = null;
    }
    state.error = null;
    state.pending = true;
  },
  update(state, error = null) {
    state.updatePending = false;
    state.updateError = error;
  },
  beforeRequest(state) {
    state.messagePending = true;
  },
  afterRequest(state, data = null) {
    if (data) {
      state.message = data;
    }
    state.messagePending = false;
  },
  beforeUpdate(state) {
    state.updateError = null;
    state.updatePending = true;
  },
  afterUpdate(state) {
    state.updatePending = false;
  },
  messages(state, messages) {
    state.pending = false;
    state.messages = messages;
  },
  paginatedMessages(state, messages) {
    state.pending = false;
    state.paginatedMessages = messages;
  },
  updateError(state, error) {
    state.updateError = error;
  },
  updated(state, message) {
    const idx = state.paginatedMessages.findIndex((u) => Number(u.id) === Number(message.id));
    if (idx !== -1) {
      Vue.set(state.paginatedMessages, idx, JSON.parse(JSON.stringify(message)));
    }
    state.updatePending = false;
  },
  deleted(state, id) {
    const idx = state.paginatedMessages.findIndex((message) => Number(message.id) === Number(id));
    if (idx !== -1) {
      state.paginatedMessages.splice(idx, 1);
    }
    state.updatePending = false;
  },
};

const actions = {
  async getPaginatedMessages({ commit }, payload) {
    try {
      const page = payload?.page || 1;
      const perPage = payload?.perPage || 10;
      const order = payload?.order ? payload.order : 'id';
      const sort = payload?.sort ? payload.sort : 'asc';
      const campaignId = payload?.campaignId ? payload.campaignId : '';
      const campaignName = payload?.campaignName ? payload.campaignName : '';
      const from = payload?.from ? payload.from : '';
      const to = payload?.to ? payload.to : '';
      const permission = payload?.permission ? payload.permission : '';
      const propertyId = payload?.propertyId ? payload.propertyId : '';
      const query = {
        page,
        perPage,
        order,
        sort,
        campaignId,
        campaignName,
        from,
        to,
        permission,
        propertyId,
      };
      const queryParams = (new URLSearchParams(query)).toString();
      const { data } = await ApiService.get(`${endpoint}/${payload.tab}?${queryParams}`);
      commit('paginatedMessages', data.content);
      return data;
    } catch (error) {
      commit('error', error);
      return [];
    }
  },
  async getMessage({ commit }, messageId) {
    commit('beforeRequest');
    try {
      const { data } = await ApiService.get(`${endpoint}/message/${messageId}`);
      commit('afterRequest', data);
      return true;
    } catch (error) {
      commit('afterRequest');
      handleApiError(commit, error);
      return false;
    }
  },
  async updateMessage({ commit }, payload) {
    commit('beforeUpdate');
    try {
      const { data } = await ApiService.put(`${endpoint}/${payload.id}`, payload);
      commit('updated', data.result);
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
  async deleteMessage({ commit }, id) {
    try {
      await ApiService.delete(`${endpoint}/${id}`);
      commit('deleted', id);
      return true;
    } catch (error) {
      handleApiError(commit, error);
      return false;
    }
  },
  async saveMessageFeedback({ commit }, payload) {
    commit('beforeUpdate');
    try {
      await ApiService.post(`${endpoint}/feedbacks`, payload);
      commit('afterUpdate');
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
  async editMessageFeedback({ commit }, data) {
    commit('beforeUpdate');
    try {
      const { id } = data;
      const payload = data;
      delete payload.id;
      await ApiService.put(`${endpoint}/feedbacks/${id}`, payload);
      commit('afterUpdate');
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
  async deleteMessageFeedback({ commit }, payload) {
    commit('beforeUpdate');
    try {
      await ApiService.delete(`${endpoint}/feedbacks/${payload.id}`);
      commit('afterUpdate');
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
